<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <StateListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import StateListing from "@/views/pages/admin/state/stateListing";

export default {
    page: {
        title: i18n.t("module.state"),
    },
    components: { Layout, PageHeader, StateListing },
    data() {
        return {
            title: i18n.t("module.state"),
            items: [
                {
                    text: i18n.t("module.workplace"),
                    href: "/workplaces",
                },
                {
                    text: i18n.t("module.state"),
                    active: true,
                },
            ],
        };
    },
}
</script>
